module.exports = __webpack_public_path__ + "img/ads-phone.0af1b312.png";